import { useQuery } from '@tanstack/react-query';
import { ApiError } from '../api/client';
import { loansApi, type LoanListResponse } from '../api/services/loans';

export function useActiveLoans(params?: {
  status?: string;
  collateralType?: string;
  search?: string;
  page?: number;
  limit?: number;
}) {
  return useQuery<LoanListResponse>({
    queryKey: ['admin', 'loans', 'active', params],
    queryFn: () => loansApi.list(params),
    // The loans read is server-gated on enableLosPreview and 404s BY DESIGN
    // for tenants without the flag (403 is the same class). Retrying a
    // deterministic gate keeps consumers in isLoading through the whole
    // backoff ladder -- the list-a-loan wizard rendered an endless skeleton
    // instead of its honest gated state. Fail fast on 404/403; keep the
    // default transient-failure retries otherwise.
    retry: (failureCount, error) => {
      if (error instanceof ApiError && (error.status === 404 || error.status === 403)) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
